var map = {
	"./Branchtrack_simulations_1.png": "Pjlf",
	"./Branchtrack_simulations_2.png": "HdEg",
	"./Branchtrack_simulations_3.png": "wSjT",
	"./Manage_processes_GDPR_Awareness_Training.png": "kTy6",
	"./ManagementABC_Defining_Objectives_and_Tasks.png": "jbTs",
	"./ManagementABC_Delegating.png": "+Cc4",
	"./ManagementABC_Giving_Feedback.png": "y1Cb",
	"./ManagementABC_Task_Performance_Control.png": "OiQv",
	"./Procrastination.png": "ucvR",
	"./badge.png": "A2cm",
	"./close-cross.png": "LmR+",
	"./duration_icon.jpg": "lZuU",
	"./emotion_management.png": "Phjz",
	"./hero.jpg": "VTGo",
	"./hero.png": "mXZL",
	"./hero_old.jpg": "Xl4M",
	"./left_arrow.png": "XlQe",
	"./loading.gif": "G/2H",
	"./loading.svg": "nuJt",
	"./logo.png": "7Otq",
	"./logoEN.png": "ZCKC",
	"./lvm.png": "NBdk",
	"./managementABC_From_Specialist_to_Manager.png": "zE//",
	"./right_arrow.png": "BRS8",
	"./rocket.png": "BHat",
	"./stress_management.png": "HkXa",
	"./swedbank.png": "f8L0",
	"./tick.png": "l3uH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0